import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faNewspaper, faTimes } from "@fortawesome/pro-solid-svg-icons";

import { useRouteTopLevelReference } from "utils/useRouteTopLevelReference";
import { usePrevious } from "utils/hooks";
import { useRoutes } from "utils/routes";

import Button from "ui/Button";
import PageOnboardingNav from "frame/PageOnboardingNav";
import PageUserNav from "frame/PageUserNav";
import {
  useCurrentOrganization,
  useCurrentServer,
} from "providers/WithCurrentOrganization";

import NavItems from "../PageSideNav/NavItems";
import OrganizationSelect from "../PageSideNav/OrganizationSelect";

import styles from "./style.module.scss";
import NavItem from "./NavItem";

import { useAppConfig } from "providers/WithAppConfig";

const PageSideNav = () => {
  const { root, changelog } = useRoutes();
  const [navOpen, setNavOpen] = useState(false);
  const toggleNav = () => {
    setNavOpen((navState) => !navState);
  };
  const location = useLocation();
  const lastLocation = usePrevious(location);
  useEffect(() => {
    if (location !== lastLocation) {
      setNavOpen(false);
    }
  }, [location, lastLocation]);

  const { humanId: serverId } = useCurrentServer(true) || {};
  const { databaseId, serverGroupId } = useRouteTopLevelReference();
  const { enterpriseEdition, enterpriseVersion } = useAppConfig();

  const currentOrganization = useCurrentOrganization(true);
  const organizationSlug = currentOrganization?.slug;

  return (
    <div className={styles.logoAndNav}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <h1>
            <Link to={root()}>
              <span>pganalyze</span>
            </Link>
          </h1>
        </div>
        <Button bare onClick={toggleNav} className={styles.navOpenBtn}>
          <div className="p-[20px] h-[60px]">
            <FontAwesomeIcon
              icon={navOpen ? faTimes : faBars}
              className="text-white text-[20px]"
            />
          </div>
        </Button>
      </div>
      <div className={navOpen ? styles.navOpen : styles.navClosed}>
        <ul className={styles.menu}>
          <OrganizationSelect />
          <NavItems
            organizationSlug={organizationSlug}
            serverId={serverId}
            databaseId={databaseId}
            serverGroupId={serverGroupId}
          />
        </ul>
        <div>
          {enterpriseEdition ? (
            enterpriseVersion && (
              <NavItem
                to="https://pganalyze.com/docs/enterprise/releases"
                icon={faNewspaper}
                matchPaths={[]}
              >
                {enterpriseVersion}
              </NavItem>
            )
          ) : (
            <NavItem
              to={changelog()}
              icon={faNewspaper}
              matchPaths={["/changelog"]}
            >
              What's New
            </NavItem>
          )}
          <PageOnboardingNav />
          <PageUserNav className={styles.userNav} />
        </div>
      </div>
    </div>
  );
};

export default PageSideNav;
